module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-mask-parent query-ai-component"
  }, [_c('component-title', {
    attrs: {
      "config": _vm.config
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.loadMask
  }), _vm._v(" "), _c('div', {
    staticClass: "query-ai-content"
  }, [_vm._l((_vm.messages), function(message) {
    return [_c('p', {
      class: 'query-ai-content-dialog query-ai-content-dialog-' + message.getType(),
      domProps: {
        "innerHTML": _vm._s(message.getMessage())
      }
    })]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "textarea-placeholder"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "maxlength": "1000",
      "placeholder": _vm.t('Type your message here') + '...'
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pushMessage($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-confirm scroll-top-btn",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_vm._v(_vm._s(_vm.t('Scroll to top')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info push-message-btn",
    on: {
      "click": _vm.pushMessage
    }
  }, [_vm._v(_vm._s(_vm.t('Send')))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71a1b0a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QueryAIComponent.vue
// module id = 1320
// module chunks = 2